import { useEffect, useState } from 'react';
import {
  getPrompts,
  updatePrompts,
  //   updatePrompt, // Assume you have this
} from '../../../services/api';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  InputGroup,
  Input,
  InputGroupText,
  Row,
} from 'reactstrap';
import Breadcrumbs from '../../../coreComponents/breadcrumbs';
import CommonCardHeader from '../../../coreComponents/CommonCardHeader';
import {
  OpenAI,
  PromptsListCardTitle,
  PromptsPageTitle,
  PropmtsInputsNames,
} from '../../../constants';
import { Prompt } from '../../../types/Prompts';
import { useTranslation } from 'react-i18next';
import ScrollBar from 'react-perfect-scrollbar';

type PromptEntry = {
  name: string;
  title: string;
  value: string | number;
  editing?: boolean;
};

const PromptsPageContainer = () => {
  const { t } = useTranslation();
  const [prompts, setPrompts] = useState<PromptEntry[]>([]);

  const promptsToArray = (data: Prompt): PromptEntry[] => {
    return Object.entries(data)
      .filter(([key]) => key !== 'id') // ✅ Skip `id`
      .map(([key, value]) => ({
        name: key,
        title: t(`openai.propmtsInputsNames.${key}`) ?? key,
        value,
        editing: false,
      }));
  };
  useEffect(() => {
    const fetchPrompts = async () => {
      const res: Prompt[] = await getPrompts();
      const promptData = res[0];

      const promptsList: PromptEntry[] = promptsToArray(promptData);

      setPrompts(promptsList);
    };

    fetchPrompts();
  }, []);

  const handleInputChange = (name: string, value: string) => {
    setPrompts((prev) => prev.map((p) => (p.name === name ? { ...p, value } : p)));
  };

  const toggleEdit = (name: string) => {
    setPrompts((prev) => prev.map((p) => (p.name === name ? { ...p, editing: !p.editing } : p)));
  };

  const handleSave = async (name: string) => {
    // toggleEdit(name);
    const promptToUpdate = prompts.find((p) => p.name === name);
    if (!promptToUpdate) return;
    try {
      const res = await updatePrompts(name, promptToUpdate.value); // You need this API
      toggleEdit(name);
      if (res.success) {
        const promptsList: PromptEntry[] = promptsToArray(res.updatedPrompts);
        setPrompts(promptsList);
      }
    } catch (e) {
      console.error('Failed to save', e);
    }
  };

  return (
    <>
      <Breadcrumbs mainTitle={t('openai.promptsPageTitle')} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={t('openai.promptsListCardTitle')} tag />
              <CardBody>
                {prompts.map((prompt) => (
                  <InputGroup key={prompt.name} className="mb-3">
                    <InputGroupText
                      style={{ width: '250px', textWrap: 'pretty', textAlign: 'start' }}
                    >
                      {prompt.title}
                    </InputGroupText>
                    <Input
                      type="textarea"
                      value={String(prompt.value)}
                      rows={6}
                      disabled={!prompt.editing}
                      style={{
                        resize: 'none',
                        overflow: 'scroll-y',
                        height: 'auto',
                      }}
                      onInput={(e) => {
                        const textarea = e.target as HTMLTextAreaElement;
                        textarea.style.height = 'auto';
                        textarea.style.height = textarea.scrollHeight + 'px';
                      }}
                      onChange={(e) => handleInputChange(prompt.name, e.target.value)}
                    />
                    <Button
                      color={prompt.editing ? 'success' : 'primary'}
                      onClick={() =>
                        prompt.editing ? handleSave(prompt.name) : toggleEdit(prompt.name)
                      }
                    >
                      {prompt.editing ? t('global.save') : t('global.edit')}
                    </Button>
                  </InputGroup>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PromptsPageContainer;
